import { render } from "./App.vue?vue&type=template&id=4caa345a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4caa345a&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__